import React from 'react';

function About() {
  return (
    <section className="py-5" id = "about">
      <div className="container">
        <h2>About Me</h2>
        <p>Hey People welcome to my portfolio . Here you can checkout my - Projects, Skills, Achievements etc.</p>
      </div>
    </section>
  );
}

export default About;